/**
 * SSO public identifiers shared across ALL environments.
 *
 * These values (MSAL client ID, tenant ID, scopes) do NOT change between
 * DEV/UAT/RC/PROD — only the URLs do. Keeping them in one file avoids
 * duplicating the same OAuth config in 6 per-env files (and risking
 * drift if one is updated but not the others).
 *
 * In a future iteration, these will be injected from
 * `.config/mobile-staff/.env` at build time (see .config/README.md).
 * For now, they live here as compile-time constants.
 */
export const SHARED_SSO = {
	msal: {
		clientId: '888a31ce-59d3-4a12-a596-8d62f641b505',
		tenantId: '6f411982-cf23-4e45-9449-4b607b7a88ec',
		// Authority URL is derived from tenantId at build time below.
		scopes: ['openid', 'profile', 'email', 'User.Read'] as const,
	},
} as const;

// Derived authority URL (don't change unless MSAL changes the auth endpoint).
export const SHARED_AUTHORITY = `https://login.microsoftonline.com/${SHARED_SSO.msal.tenantId}`;
